import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import validateField from '../../validation';
import AmplifyWrapper from '../../../service/auth.service';
import { connect } from 'react-redux';
import { saveSettings } from '../../../actions/save-settings-actions';
import { initializeApplication } from '../../../actions/initialize-application-actions';
import { withTranslation } from 'react-i18next';
import { Auth } from 'aws-amplify';
import QRCode from 'qrcode-react';
import './Settings.scss';

import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
//import TabPanel from '@material-ui/core/Tabs';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div component="div" role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
			{value === index &&
				<div p={3}>
					{children}
				</div>}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired
};

class Settings extends React.Component {
	/**
     * 
     * @param {*} props 
     */
	constructor(props) {
		super(props);
		this.state = {
			mfaTabsSelectedIndex: this.getSelectedMFAType2(),
			qrCode: null,
			totpCode: ''
		};
	}

	/**
     * 
     */
	componentDidMount() {}

	/**
     * 
     * @param {*} e 
     */
	onSendSMSBtnClick(e) {
		AmplifyWrapper.verifyCurrentUserAttribute('phone_number')
			.then(() => {
				console.log('a verification code is sent');
			})
			.catch(e => {
				console.log('failed with error', e);
			});
	}

	/**
     * 
     * @param {*} e 
     */
	onConfirmBtnClick(e) {
		AmplifyWrapper.verifyCurrentUserAttributeSubmit('phone_number', this.state.code)
			.then(() => {
				console.log('phone_number verified');
				this.props.initializeApplication();
			})
			.catch(e => {
				console.log('failed with error', e);
			});
	}

	/**
     * 
     * @param {*} e 
     */
	handleChange(e) {
		this.setState({ [e.target.id]: e.target.value });
		//
		setTimeout(this.validateForm.bind(this, 200));
	}

	/**
     * 
     */
	validateForm() {
		if (validateField('verificationCode', this.state.code) === true) {
			this.setState({ formValid: true });
		} else {
			this.setState({ formValid: false });
		}
	}

	/* async onMfaChange(e) {
		const method = e.target.value;
		var user = await AmplifyWrapper.currentAuthenticatedUser();
		console.log(user);
		Auth.setPreferredMFA(user, method)
			.then(data => {
				console.log(data);
				// ...
			})
			.catch(e => {
				console.log(e);
			});
	} */

	async setupTOPT() {
		var user = await AmplifyWrapper.currentAuthenticatedUser();

		Auth.setupTOTP(user).then(code => {
			const username = user.username;
			const issuer = 'PlatformX';
			const str = 'otpauth://totp/AWSCognito-usr:' + username + '?secret=' + code + '&issuer=' + issuer;
			this.setState({ qrCode: str, qrCodeKey: code });
			//
		});
	}

	async verifyTOPT() {
		var user = await AmplifyWrapper.currentAuthenticatedUser();
		Auth.verifyTotpToken(user, this.state.totpCode)
			.then(() => {
				// don't forget to set TOTP as the preferred MFA method
				Auth.setPreferredMFA(user, 'TOTP')
					.then(data => {
						console.log(data);
						// ...
						this.props.initializeApplication();
					})
					.catch(e => {
						console.log(e);
					});
				// ...
			})
			.catch(e => {
				// Token is not verified
			});
	}

	handleTOTPChange(e) {
		this.setState({ totpCode: e.currentTarget.value });
	}

	getSelectedMFAType2() {
		const options = { SMS_MFA: 2, SOFTWARE_TOKEN_MFA: 1, NOMFA: 0 };
		return options[this.props.user.userData.preferredMFA] || 0;
	}

	getSelectedMFAType() {
		const options = { SMS_MFA: 'SMS', SOFTWARE_TOKEN_MFA: 'TOTP', NOMFA: 'NOMFA' };
		return options[this.props.user.userData.preferredMFA] || 'NOMFA';

		/* switch (this.props.user.userData.preferredMFA) {
			case 'SMS_MFA':
				return 'SMS';
				break;
			case 'SOFTWARE_TOKEN_MFA':
				return 'TOTP';
				break;
			case 'NOMFA':
				return 'NOMFA';
				break;
		} */
		//return 'SMS';
	}
	onTabChange(e, value) {
		this.setState({ mfaTabsSelectedIndex: value });
	}
	async onDisableMFAClick() {
		var user = await AmplifyWrapper.currentAuthenticatedUser();
		Auth.setPreferredMFA(user, 'NOMFA')
			.then(data => {
				console.log(data);
				// ...
				this.props.initializeApplication();
			})
			.catch(e => {
				console.log(e);
			});
	}

	async onEnableSMSMFAClick() {
		var user = await AmplifyWrapper.currentAuthenticatedUser();
		Auth.setPreferredMFA(user, 'SMS')
			.then(data => {
				console.log(data);
				// ...
				this.props.initializeApplication();
			})
			.catch(e => {
				console.log(e);
			});
	}

	isPhoneVerified() {
		if (!this.props.user.userData.attributes) {
			return false;
		}
		return this.props.user.userData.attributes.phone_number_verified;
	}
	/**
     * 
     */
	render() {
		let html = [];
		var attributes = this.props.user.userData.attributes;
		for (var i in attributes) {
			html.push(
				<li key={i}>
					<div>
						<strong>{i}</strong>: {attributes[i] == true ? 'Yes' : attributes[i]}
					</div>
				</li>
			);
		}

		const list = (
			<ul>
				{html}
			</ul>
		);

		return (
			<div className="Settings">
				<div className="container">
					<h1>
						{this.props.user.userData.username}
					</h1>

					<ul>
						<li>
							<div>
								<strong>Client id</strong>: {this.props.user.userData.pool.clientId}
							</div>
						</li>
						<li>
							<div>
								<strong>User pool id</strong>: {this.props.user.userData.pool.userPoolId}
							</div>
						</li>
					</ul>
					<hr />
					<div>
						{list}
					</div>
				</div>

				<div className="container">
					<h1>Multi factor authentication (MFA)</h1>
					<hr />
					<div>
						<Tabs variant="fullWidth" onChange={this.onTabChange.bind(this)} value={this.state.mfaTabsSelectedIndex} aria-label="simple tabs example">
							<Tab label="Disable" id={0} />
							<Tab label="Software token (TOTP)" id={1} />
							<Tab label="SMS" id={2} />
						</Tabs>
					</div>

					<div>
						<TabPanel value={this.state.mfaTabsSelectedIndex} index={0}>
							<h2>Disable Multi Factor Authentication</h2>
							<p>
								{this.props.user.userData.preferredMFA === 'NOMFA' ? 'MFA is currently disabled for your account.' : 'If you want to disable MFA for your account, click the button below'}
							</p>
							<Button disabled={this.props.user.userData.preferredMFA === 'NOMFA'} className="btnAction" variant="contained" color="primary" onClick={this.onDisableMFAClick.bind(this)}>
								Disable MFA
							</Button>
						</TabPanel>
						<TabPanel value={this.state.mfaTabsSelectedIndex} index={1}>
							<h2>Enable software token based MFA</h2>
							<div>
								<p>
									{this.props.user.userData.preferredMFA !== 'SOFTWARE_TOKEN_MFA' ? ' Enable MFA with use of an 3rd party app. (Like Google authenticator)' : 'TOTP MFA is currently enabled'}
								</p>

								<Button className="btnAction" variant="contained" color="primary" onClick={this.setupTOPT.bind(this)}>
									{this.state.qrCode !== null ? 'Re-generate QR code' : 'Generate QR code'}
								</Button>

								<div>
									{this.state.qrCode !== null && this.props.user.userData.preferredMFA !== 'SOFTWARE_TOKEN_MFA'
										? <div>
												<div>Scan this code with your authenticator app and fill in the code below</div>
												<br />
												<QRCode value={this.state.qrCode} />
												<div>
													{this.state.qrCodeKey}
												</div>

												<div className="totpCodeCtrl">
													<TextField className="textField" id="totpCode" label="Enter TOTP code here" margin="normal" variant="outlined" onChange={this.handleTOTPChange.bind(this)} />
													<Button className="btnAction" variant="contained" color="primary" onClick={this.verifyTOPT.bind(this)}>
														Submit
													</Button>
												</div>
											</div>
										: null}
								</div>
							</div>
						</TabPanel>
						<TabPanel value={this.state.mfaTabsSelectedIndex} index={2}>
							<h2>Enable SMS based MFA</h2>
							{this.isPhoneVerified() !== true
								? <div>
										<div>
											<h1>
												{this.props.t('translation:settings:headerLbl')}
											</h1>
											<div>
												<p>
													{this.props.t('translation:settings:verificationDesciription')}
												</p>
											</div>
											<div>
												<Button className="btnAction" variant="contained" color="primary" onClick={this.onSendSMSBtnClick.bind(this)}>
													{this.props.t('translation:settings:sendSMSButtonLabel')}
												</Button>
											</div>
										</div>
										<div className="formBox">
											<div>
												<TextField
													id="code"
													label={this.props.t('translation:settings:codeInputLabel')}
													margin="normal"
													variant="outlined"
													value={this.props.code}
													disabled={this.state.isLoading}
													onChange={e => this.handleChange(e)}
												/>
											</div>
										</div>
										<div>
											<div>
												<Button className="btnAction" variant="contained" color="primary" onClick={this.onConfirmBtnClick.bind(this)}>
													{this.props.t('translation:settings:submitButtonLabel')}
												</Button>
											</div>
										</div>
									</div>
								: <div>
										<div>
											<Button disabled={this.props.user.userData.preferredMFA === 'SMS_MFA'} className="btnAction" variant="contained" color="primary" onClick={this.onEnableSMSMFAClick.bind(this)}>
												Enable SMS MFA
											</Button>
										</div>
									</div>}
						</TabPanel>
					</div>
				</div>
			</div>
		);
	}
}

/**
 * 
 * @param {*} state 
 */
const mapStateToProps = state => {
	return {
		user: state.user,
		username: state.settings.username,
		email: state.settings.email
	};
};

/**
 * 
 * @param {*} dispatch 
 */
const mapDispatchToProps = dispatch => {
	return {
		initializeApplication: () => dispatch(initializeApplication()),
		saveSettings: (username, email) => dispatch(saveSettings(username, email))
	};
};

/**
 * 
 */
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Settings));
